import { Injectable } from "@angular/core";
import { FormDataService } from "../data/form-data.service";
import { Router } from "@angular/router";

@Injectable({
  providedIn: "root",
})
export class StepThreeGuardService {
  constructor(private formData: FormDataService, public router: Router) {}

  canActivate(): boolean {
    let isOpenTicket = localStorage.getItem("is_open_ticket");
    let location_permalink = localStorage.getItem("location_permalink");
    let course_id_from_url = localStorage.getItem("course_id_from_url");
    let date_url = localStorage.getItem("date_url");

    if(isOpenTicket === "true"){
      return true;
    }

    if(location_permalink && course_id_from_url && date_url){
      return true;
    }

    let location = localStorage.getItem("location_selected");
    if (!location) {
      this.router.navigate(["/locations"], { queryParamsHandling: "merge" });
      return false;
    }
    let course = localStorage.getItem("course_selected");
    if (!course && location) {
      this.router.navigate(["/type"], { queryParamsHandling: "merge" });
      return false;
    }else if(!course && !location){
      this.router.navigate(["/locations"], { queryParamsHandling: "merge" });
      return false;
    }
    return true;
  }
}
